import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import anjuros.development.pages.HomePage as _anjuros_development_pages_HomePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Noclegi Skwarek"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _anjuros_development_pages_HomePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("main-header-contact", anjuros.development.util.MainHeaderContactStyle)
        ctx.theme.registerStyle("navigation-item", anjuros.development.util.NavigationItemStyle)
        ctx.theme.registerStyle("menu-width", anjuros.development.util.MenuWidthStyle)
        ctx.theme.registerStyle("contact-me-details-font", anjuros.development.util.ContactMeDetailsFontStyle)
        ctx.theme.registerStyle("contact-button", anjuros.development.util.ContactButtonStyle)
        ctx.theme.registerStyle("room-column-width", anjuros.development.util.RoomColumnWidthStyle)
        ctx.theme.registerStyle("small-section-width", anjuros.development.util.SmallSectionWidthStyle)
        ctx.theme.registerStyle("review-arrow", anjuros.development.util.ReviewArrowStyle)
        ctx.theme.registerStyle("review-single-card-width", anjuros.development.util.ReviewSingleCardWidthStyle)
        ctx.theme.registerStyle("review-card-max-width", anjuros.development.util.ReviewCardMaxWidthStyle)
        ctx.theme.registerStyle("room-card-size", anjuros.development.util.RoomCardSizeStyle)
        ctx.theme.registerStyle("room-image", anjuros.development.util.RoomImageStyle)
        ctx.theme.registerStyle("room-zoom-image", anjuros.development.util.RoomZoomImageStyle)
        ctx.theme.registerStyle("room-card", anjuros.development.util.RoomCardStyle)
        ctx.theme.registerStyle("nearby-rotation", anjuros.development.util.NearbyRotationStyle)
        ctx.theme.registerStyle("faq-header", anjuros.development.util.FaqHeaderStyle)
        ctx.theme.registerStyle("faq-subheader", anjuros.development.util.FaqSubheaderStyle)
        ctx.theme.registerStyle("faq-width", anjuros.development.util.FaqWidthStyle)
        ctx.theme.registerStyle("navigation-footer-item", anjuros.development.util.NavigationFooterItemStyle)
        ctx.theme.registerStyle("footer-margin", anjuros.development.util.FooterMarginStyle)
        anjuros.development.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        anjuros.development.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
